<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl"><icon name="home" class="w-6 h-6 -mt-1 mr-2 inline-block" /> Listado de Inmuebles</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" :show-filter="true" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('properties.create')">
        <span>Crear</span>
        <span class="hidden md:inline">Inmueble</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Operacion</th>
          <th class="px-6 pt-6 pb-4">Anunciante</th>
          <th class="px-6 pt-6 pb-4">Tipo</th>
          <th class="px-6 pt-6 pb-4">Zona</th>
        </tr>
        <tr v-for="property in properties.data" :key="property.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t" >
           
            <inertia-link :class="property.desactivada ? 'text-red-500' : 'text-blue-800'" class="px-6 py-4 flex items-center " :href="route('properties.edit', property.ID)">
              {{ property.nombre }}<div v-if="property.desactivada" class="w-4 h-4 ml-2  bg-red-500 inline-block rounded-full"></div>
              <span v-if="property.patrocinada" class="bg-blue-400 text-sm text-white px-2 py-1 rounded-md ml-2"> Patrocinada <icon name="star" class="w-6 h-6 -mt-1  inline-block fill-white" /> </span>

            </inertia-link>

          </td>
          <td class="border-t px-6">
             <div v-if="property.operacion == 1">
                <div  class="bg-indigo-500 px-3 py-1 text-white text-center inline-block font-semibold rounded"  >Alquiler</div>
              </div>
              <div v-if="property.operacion == 2">
                <div  class="bg-green-500 px-4 py-1 text-white text-center inline-block font-semibold rounded"  >Venta</div>

              </div>
              <div v-if="property.operacion == 3">
                <div  class="bg-yellow-500 px-4 py-1 text-white text-center inline-block font-semibold rounded" >Transitorio</div>

              </div>
          </td>
          <td class="border-t">
             <div v-if="property.advertiser">
              
                <inertia-link class="px-6 py-4 flex items-center text-blue-800" :href="route('advertisers.edit', property.advertiser.ID)">
                <icon name="users" class="w-4 h-4 mr-2 fill-blue-400" />{{ property.advertiser.usuario }}  
               <small v-if="property.advertiser.nombre" class="mt-1 ml-1">
                     - {{ property.advertiser.nombre }}
               </small>
               
               
            </inertia-link>
               
              </div>
          </td>
         
           <td class="border-t px-6">
              <ul>
               <li v-for="t in propertyType" :key="t.id" >
                 <div v-if="t.id == property.tipo_inmueble">
                {{t.name}}
              </div>
            
          </li>
             </ul>
             <!-- {{ property.tipo_inmueble }}  -->
          </td>

          
           
           <td class="border-t  px-6">
             <ul>
               <li v-for="loc in location" :key="loc.id" >
                 <div v-if="loc.id == property.zona">
                {{loc.name}}
              </div>
            
          </li>
             </ul>
             
             <!-- {{ property.zona}} -->
          </td>

          
        </tr>
        <tr v-if="properties.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron inmuebles.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="properties.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import locationData from "@/Shared/locations.json";
import propertyType from "@/Shared/propertyType.json";

export default {
  metaInfo: { title: 'Inmuebles' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    properties: Object,
  },
  data() {
    return {
      location: locationData,
      propertyType,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('properties'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
